import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_FORMFIELD, KENDO_TEXTAREA } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { ControlWrapperComponent } from '@unity/forms/composed/control-wrapper/control-wrapper.component';

@Component({
  selector: 'unity-textarea-control',
  standalone: true,
  imports: [KENDO_FORMFIELD, KENDO_TEXTAREA, KENDO_LABEL, ReactiveFormsModule, ControlWrapperComponent],
  templateUrl: './textarea-control.component.html',
  styleUrl: './textarea-control.component.scss',
})
export class TextareaControlComponent {
  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });

  public readonly $showHint = input(true, { alias: 'showHint' });
}
